(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["escola-parceira"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initPartnerPage = (root) => {
      if (!root || root.dataset.caInit === 'true') return;
      root.dataset.caInit = 'true';

      const cart = root.querySelector('[data-ca-cart]');
      const overlay = root.querySelector('[data-ca-overlay]');
      const cartView = root.querySelector('[data-ca-cart-view]');
      const registrationView = root.querySelector('[data-ca-registration]');
      const cartFoot = root.querySelector('[data-ca-cart-foot]');
      const itemsList = root.querySelector('[data-ca-items]');
      const emptyState = root.querySelector('[data-ca-empty]');
      const cartLoading = root.querySelector('[data-ca-cart-loading]');
      const cartError = root.querySelector('[data-ca-cart-error]');
      const form = root.querySelector('[data-ca-form]');
      const formError = root.querySelector('[data-ca-form-error]');
      const toast = root.querySelector('[data-ca-toast]');
      const openCartButton = root.querySelector('[data-ca-open-cart]');
      const checkoutButton = root.querySelector('[data-ca-checkout]');
      const addButtons = root.querySelectorAll('[data-ca-add]');
      const pageRegions = root.querySelectorAll('.ca-skip, .ca-topbar, .ca-header, .ca-main, .ca-footer');

      const schoolName = root.dataset.caSchoolName || '';
      const schoolKey = root.dataset.caSchoolKey || '';
      const publisherName = root.dataset.caPublisherName || 'Editora Ordo Naturalis';
      const placeholderImage = root.dataset.caPlaceholder || '';
      const cartUrl = root.dataset.caCartUrl || '/cart';
      const cartAddUrl = root.dataset.caCartAddUrl || '/cart/add.js';
      const cartChangeUrl = root.dataset.caCartChangeUrl || '/cart/change.js';
      const cartUpdateUrl = root.dataset.caCartUpdateUrl || '/cart/update.js';
      const checkoutUrl = root.dataset.caCheckoutUrl || '/checkout';
      const priceGuard = root.dataset.caPriceGuard === 'true';
      const partnerPrice = Number(root.dataset.caPartnerPrice || 0);
      const currencyCode = root.dataset.caCurrency || 'BRL';

      const money = new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: currencyCode
      });

      let cartState = { items: [], item_count: 0, total_price: 0 };
      let lastFocused = null;
      let toastTimer = null;
      let isSaving = false;
      let cartRefreshPromise = null;

      const escapeHtml = (value) => String(value ?? '').replace(/[&<>"']/g, (char) => ({
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;'
      }[char]));

      const formatMoney = (cents) => money.format((Number(cents) || 0) / 100);

      const prop = (item, key) => {
        const value = item && item.properties ? item.properties[key] : '';
        return Array.isArray(value) ? value.filter(Boolean).join(', ') : (value || '');
      };

      const allowedVariantIds = new Set(
        Array.from(root.querySelectorAll('[data-ca-book]'))
          .map((card) => Number(card.dataset.caVariantId))
          .filter(Boolean)
      );

      const isCartItemFromThisSchool = (item) => {
        const itemSchool = prop(item, '_school_key');
        if (itemSchool) return itemSchool === schoolKey;
        return allowedVariantIds.has(Number(item.variant_id));
      };

      const showToast = (message, tone = 'success') => {
        if (!toast) return;
        toast.textContent = message;
        toast.dataset.tone = tone;
        toast.dataset.visible = 'true';
        window.clearTimeout(toastTimer);
        toastTimer = window.setTimeout(() => {
          toast.dataset.visible = 'false';
        }, 3800);
      };

      const setPageInert = (isInert) => {
        pageRegions.forEach((region) => {
          if (isInert) {
            region.setAttribute('inert', '');
          } else {
            region.removeAttribute('inert');
          }
        });
      };

      const setCartCount = (count) => {
        root.querySelectorAll('[data-ca-cart-count]').forEach((node) => {
          node.textContent = String(count || 0);
        });
      };

      const setLoading = (isLoading) => {
        if (!cartLoading) return;
        cartLoading.hidden = !isLoading;
        if (itemsList) itemsList.setAttribute('aria-busy', isLoading ? 'true' : 'false');
      };

      const setCartError = (message = '') => {
        if (!cartError) return;
        cartError.textContent = message;
        cartError.hidden = !message;
      };

      const fetchCart = async () => {
        const response = await fetch(`${cartUrl}.js`, {
          headers: { Accept: 'application/json' },
          credentials: 'same-origin'
        });
        if (!response.ok) throw new Error('Não foi possível carregar o carrinho.');
        return response.json();
      };

      const renderCart = (nextCart) => {
        cartState = nextCart || { items: [], item_count: 0, total_price: 0 };
        setCartCount(cartState.item_count);
        const hasItems = Array.isArray(cartState.items) && cartState.items.length > 0;

        if (emptyState) emptyState.hidden = hasItems;
        if (itemsList) itemsList.hidden = !hasItems;
        if (cartFoot) cartFoot.hidden = !hasItems;
        if (checkoutButton) checkoutButton.disabled = !hasItems;

        root.querySelectorAll('[data-ca-total]').forEach((node) => {
          node.textContent = formatMoney(cartState.total_price);
        });

        if (!itemsList) return;

        itemsList.innerHTML = cartState.items.map((item) => {
          const childName = prop(item, 'Nome do filho(a)');
          const childClass = prop(item, 'Turma do aluno');
          const childLabel = [childName, childClass].filter(Boolean).join(' · ');
          const grade = prop(item, 'Série');
          const title = item.product_title || item.title || 'Livro';
          const image = item.image || placeholderImage;
          const imageMarkup = image
            ? `<img class="ca-cart-item__image" src="${escapeHtml(image)}" alt="" width="66" height="84" loading="lazy">`
            : `<span class="ca-cart-item__placeholder" aria-hidden="true">${escapeHtml((grade || title).slice(0, 1).toUpperCase())}</span>`;

          return `
            <li class="ca-cart-item">
              ${imageMarkup}
              <div class="ca-cart-item__info">
                <p class="ca-cart-item__title">${escapeHtml(title)}</p>
                ${grade ? `<p class="ca-cart-item__grade">${escapeHtml(grade)}</p>` : ''}
                ${childLabel ? `<p class="ca-cart-item__child"><svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m5 12 5 5L20 7"/></svg>${escapeHtml(childLabel)}</p>` : ''}
                <p class="ca-cart-item__price">${formatMoney(item.final_line_price ?? item.line_price ?? item.price)}</p>
              </div>
              <button class="ca-cart-item__remove" type="button" data-ca-remove="${escapeHtml(item.key)}">Remover</button>
            </li>
          `;
        }).join('');

        const childNames = cartState.items
          .map((item) => {
            const name = prop(item, 'Nome do filho(a)');
            const childClass = prop(item, 'Turma do aluno');
            return [name, childClass].filter(Boolean).join(' — ');
          })
          .filter(Boolean);

        const summary = root.querySelector('[data-ca-child-summary]');
        if (summary) {
          summary.innerHTML = childNames.length
            ? `<strong>Aluno(s) neste pedido</strong>${escapeHtml(childNames.join(' · '))}`
            : '';
          summary.hidden = childNames.length === 0;
        }
      };

      const refreshCart = async (showLoading = true) => {
        if (cartRefreshPromise) return cartRefreshPromise;

        if (showLoading) setLoading(true);
        setCartError('');

        cartRefreshPromise = (async () => {
          try {
            let nextCart = await fetchCart();

            if (Array.isArray(nextCart.items) && nextCart.items.length > 0) {
              const hasForeignItem = nextCart.items.some((item) => !isCartItemFromThisSchool(item));
              if (hasForeignItem) {
                const clearResponse = await fetch(`${cartUrl}/clear.js`, {
                  method: 'POST',
                  headers: { Accept: 'application/json' },
                  credentials: 'same-origin'
                });
                if (!clearResponse.ok) {
                  throw new Error('Não foi possível limpar o carrinho.');
                }
                try {
                  localStorage.removeItem('ordo_naturalis_cart_v5');
                } catch (e) {}
                nextCart = { items: [], item_count: 0, total_price: 0 };
              }
            }

            renderCart(nextCart);
            return nextCart;
          } catch (error) {
            setCartError(error.message || 'Não foi possível carregar o carrinho.');
            return cartState;
          } finally {
            if (showLoading) setLoading(false);
          }
        })();

        try {
          return await cartRefreshPromise;
        } finally {
          cartRefreshPromise = null;
        }
      };

      const openCart = async (view = 'cart') => {
        if (!cart || !overlay) return;
        lastFocused = document.activeElement;
        overlay.hidden = false;
        cart.hidden = false;
        cart.setAttribute('aria-hidden', 'false');
        if (openCartButton) openCartButton.setAttribute('aria-expanded', 'true');
        setPageInert(true);
        document.body.classList.add('ca-no-scroll');
        await refreshCart();
        if (view === 'registration') {
          showRegistration();
        } else {
          showCartView();
        }
        const focusTarget = view === 'registration'
          ? form?.querySelector('input, button')
          : cart.querySelector('[data-ca-close-cart]');
        window.setTimeout(() => focusTarget?.focus(), 40);
      };

      const closeCart = () => {
        if (!cart || !overlay) return;
        cart.hidden = true;
        cart.setAttribute('aria-hidden', 'true');
        overlay.hidden = true;
        if (openCartButton) openCartButton.setAttribute('aria-expanded', 'false');
        setPageInert(false);
        document.body.classList.remove('ca-no-scroll');
        if (lastFocused && typeof lastFocused.focus === 'function') {
          lastFocused.focus();
        }
        lastFocused = null;
      };

      const showCartView = () => {
        if (cartView) cartView.hidden = false;
        if (registrationView) registrationView.hidden = true;
        if (cartFoot) cartFoot.hidden = cartState.items.length === 0;
      };

      const showRegistration = () => {
        if (cartState.items.length === 0) {
          showToast('Adicione um livro antes de finalizar a compra.', 'error');
          return;
        }
        if (cartView) cartView.hidden = true;
        if (registrationView) registrationView.hidden = false;
        if (cartFoot) cartFoot.hidden = true;
        updateChildSummary();
      };

      const updateChildSummary = () => {
        const summary = root.querySelector('[data-ca-child-summary]');
        if (!summary) return;
        const childNames = cartState.items
          .map((item) => {
            const name = prop(item, 'Nome do filho(a)');
            const childClass = prop(item, 'Turma do aluno');
            return [name, childClass].filter(Boolean).join(' — ');
          })
          .filter(Boolean);
        summary.innerHTML = childNames.length
          ? `<strong>Aluno(s) neste pedido</strong>${escapeHtml(childNames.join(' · '))}`
          : '';
        summary.hidden = childNames.length === 0;
      };

      const addToCart = async (button) => {
        const card = button.closest('[data-ca-book]');
        if (!card) return;
        const variantId = card.dataset.caVariantId;
        const canBuy = card.dataset.caCanBuy === 'true';
        const variantPrice = Number(card.dataset.caVariantPrice || 0);
        const cardPrice = Number(card.dataset.caPartnerPrice || partnerPrice);
        const priceOk = card.dataset.caPriceOk === 'true';
        const childInput = card.querySelector('[data-ca-child]');
        const childError = card.querySelector('[data-ca-child-error]');
        const classInput = card.querySelector('[data-ca-child-class]');
        const classError = card.querySelector('[data-ca-child-class-error]');
        const childName = childInput ? childInput.value.trim() : '';
        const childClass = classInput ? classInput.value.trim() : '';
        const title = card.dataset.caTitle || 'Livro';
        const grade = card.dataset.caGrade || '';

        if (!canBuy || !variantId) return;

        if (priceGuard && priceOk && cardPrice > 0 && variantPrice !== cardPrice) {
          showToast('O preço deste livro ainda está sendo atualizado. Fale com a escola.', 'error');
          return;
        }

        if (!childName) {
          if (childInput) {
            childInput.setAttribute('aria-invalid', 'true');
            childInput.focus();
          }
          if (childError) childError.hidden = false;
          showToast('Informe o nome do filho(a) para adicionar o livro.', 'error');
          return;
        }

        if (classInput && !childClass) {
          classInput.setAttribute('aria-invalid', 'true');
          classInput.focus();
          if (classError) classError.hidden = false;
          showToast('Informe a turma do aluno para adicionar o livro.', 'error');
          return;
        }

        const alreadyInCart = cartState.items.some((item) => (
          Number(item.variant_id) === Number(variantId)
          && prop(item, 'Nome do filho(a)').toLowerCase() === childName.toLowerCase()
          && (!childClass || prop(item, 'Turma do aluno').toLowerCase() === childClass.toLowerCase())
        ));
        if (alreadyInCart) {
          showToast('Este livro já está no carrinho para este aluno.', 'error');
          return;
        }

        if (childInput) childInput.removeAttribute('aria-invalid');
        if (childError) childError.hidden = true;
        if (classInput) classInput.removeAttribute('aria-invalid');
        if (classError) classError.hidden = true;

        const label = button.querySelector('[data-ca-add-label]');
        const originalLabel = label ? label.textContent : button.textContent;
        button.dataset.loading = 'true';
        button.disabled = true;
        if (label) label.textContent = 'Adicionando…';

        try {
          const properties = {
            'Nome do filho(a)': childName,
            'Série': grade,
            'Entrega': `Escola parceira — ${schoolName}`
          };
          if (childClass) properties['Turma do aluno'] = childClass;
          if (schoolKey) properties['_school_key'] = schoolKey;

          const response = await fetch(cartAddUrl, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json'
            },
            credentials: 'same-origin',
            body: JSON.stringify({
              items: [{
                id: Number(variantId),
                quantity: 1,
                properties
              }]
            })
          });

          const result = await response.json().catch(() => ({}));
          if (!response.ok) {
            throw new Error(result.description || result.message || 'Não foi possível adicionar o livro.');
          }

          if (childInput) childInput.value = '';
          if (classInput) classInput.value = '';
          await openCart('cart');
          showToast(`${title} adicionado ao carrinho.`);
        } catch (error) {
          showToast(error.message || 'Não foi possível adicionar o livro.', 'error');
        } finally {
          button.dataset.loading = 'false';
          button.disabled = false;
          if (label) label.textContent = originalLabel;
        }
      };

      const removeItem = async (key) => {
        try {
          const response = await fetch(cartChangeUrl, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json'
            },
            credentials: 'same-origin',
            body: JSON.stringify({ id: key, quantity: 0 })
          });
          if (!response.ok) throw new Error('Não foi possível remover o item.');
          await refreshCart();
          showToast('Livro removido do carrinho.');
        } catch (error) {
          showToast(error.message || 'Não foi possível remover o item.', 'error');
        }
      };

      const saveRegistration = async (event) => {
        event.preventDefault();
        if (!form || isSaving) return;

        if (!form.checkValidity()) {
          form.reportValidity();
          return;
        }

        const data = new FormData(form);
        const get = (key) => String(data.get(key) || '').trim();

        const attributes = {
          'Parceria': `${schoolName} × ${publisherName}`,
          'Entrega': `Escola parceira — ${schoolName}`,
          'Nome do responsável': get('parent_name'),
          'E-mail do responsável': get('parent_email'),
          'Telefone do responsável': get('parent_phone'),
          'CEP do responsável': get('parent_cep'),
          'Endereço do responsável': get('parent_address'),
          'Número do responsável': get('parent_number'),
          'Complemento do responsável': get('parent_complement'),
          'Bairro do responsável': get('parent_neighborhood'),
          'Cidade do responsável': get('parent_city'),
          'Estado do responsável': get('parent_state').toUpperCase(),
          'Aluno(s)': cartState.items.map((item) => prop(item, 'Nome do filho(a)')).filter(Boolean).join(' · ')
        };
        const classList = cartState.items.map((item) => prop(item, 'Turma do aluno')).filter(Boolean).join(' · ');
        if (classList) attributes['Turma(s)'] = classList;

        const noteParts = [
          `Pedido de parceria — ${schoolName}.`,
          'Entrega na escola.',
          'O endereço do responsável é apenas para cadastro.',
          `Aluno(s): ${attributes['Aluno(s)'] || 'não informado'}.`
        ];
        if (attributes['Turma(s)']) {
          noteParts.push(`Turma(s): ${attributes['Turma(s)']}.`);
        }
        const note = noteParts.join(' ');

        const submitButton = form.querySelector('[data-ca-submit]');
        const submitLabel = form.querySelector('[data-ca-submit-label]');
        const originalLabel = submitLabel ? submitLabel.textContent : '';
        isSaving = true;
        if (submitButton) submitButton.disabled = true;
        if (submitLabel) submitLabel.textContent = 'Salvando…';
        if (formError) formError.hidden = true;

        try {
          const response = await fetch(cartUpdateUrl, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json'
            },
            credentials: 'same-origin',
            body: JSON.stringify({ attributes, note })
          });

          const result = await response.json().catch(() => ({}));
          if (!response.ok) {
            throw new Error(result.description || result.message || 'Não foi possível salvar os dados.');
          }

          const params = new URLSearchParams();
          params.set('checkout[email]', get('parent_email'));

          window.location.href = `${checkoutUrl}?${params.toString()}`;
        } catch (error) {
          if (formError) {
            formError.textContent = error.message || 'Não foi possível salvar os dados. Tente novamente.';
            formError.hidden = false;
          }
          showToast(error.message || 'Não foi possível salvar os dados.', 'error');
        } finally {
          isSaving = false;
          if (submitButton) submitButton.disabled = false;
          if (submitLabel) submitLabel.textContent = originalLabel;
        }
      };

      const handleKeydown = (event) => {
        if (event.key === 'Escape') {
          closeCart();
          return;
        }

        if (event.key !== 'Tab' || !cart || cart.hidden) return;

        const focusable = Array.from(cart.querySelectorAll(
          'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), summary, [tabindex]:not([tabindex="-1"])'
        )).filter((element) => element.offsetParent !== null);

        if (focusable.length === 0) return;
        const first = focusable[0];
        const last = focusable[focusable.length - 1];

        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      };

      root.addEventListener('click', (event) => {
        const openButton = event.target.closest('[data-ca-open-cart]');
        if (openButton && root.contains(openButton)) {
          event.preventDefault();
          openCart('cart');
          return;
        }

        const closeButton = event.target.closest('[data-ca-close-cart]');
        if (closeButton && root.contains(closeButton)) {
          event.preventDefault();
          closeCart();
          return;
        }

        const addButton = event.target.closest('[data-ca-add]');
        if (addButton && root.contains(addButton)) {
          event.preventDefault();
          addToCart(addButton);
          return;
        }

        const removeButton = event.target.closest('[data-ca-remove]');
        if (removeButton && root.contains(removeButton)) {
          event.preventDefault();
          removeItem(removeButton.dataset.caRemove);
          return;
        }

        const checkout = event.target.closest('[data-ca-checkout]');
        if (checkout && root.contains(checkout)) {
          event.preventDefault();
          showRegistration();
          window.setTimeout(() => form?.querySelector('input')?.focus(), 40);
          return;
        }

        const backButton = event.target.closest('[data-ca-back]');
        if (backButton && root.contains(backButton)) {
          event.preventDefault();
          showCartView();
          window.setTimeout(() => cart.querySelector('[data-ca-close-cart]')?.focus(), 40);
        }
      });

      root.addEventListener('input', (event) => {
        const input = event.target.closest('[data-ca-child], [data-ca-child-class]');
        if (!input) return;
        if (input.value.trim()) {
          input.removeAttribute('aria-invalid');
          const error = input.closest('.ca-field')?.querySelector('[data-ca-child-error], [data-ca-child-class-error]');
          if (error) error.hidden = true;
        }
      });

      overlay?.addEventListener('click', closeCart);
      cart?.addEventListener('keydown', handleKeydown);
      form?.addEventListener('submit', saveRegistration);

      addButtons.forEach((button) => {
        const card = button.closest('[data-ca-book]');
        const inputs = card?.querySelectorAll('[data-ca-child], [data-ca-child-class]') || [];
        inputs.forEach((input) => {
          input.addEventListener('keydown', (event) => {
            if (event.key === 'Enter') {
              event.preventDefault();
              addToCart(button);
            }
          });
        });
      });

      refreshCart(false);
    };

    const initAllPartnerPages = () => {
      document.querySelectorAll('[data-ca-page]').forEach(initPartnerPage);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAllPartnerPages, { once: true });
    } else {
      initAllPartnerPages();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
